import axiosClient from "../axiosClient";
import { Civilite } from "../interfaces/civilite.interface";
import { Pack } from "../interfaces/pack.interface";
import { Tarif } from "../interfaces/tarif.interface";

export const findAbonnementData = async () => {
  const { data } = await axiosClient.get<{
    tarif: Tarif;
    packs: Pack[];
    civilites: Civilite[];
  }>(`/abonnements/abonnement-data`);
  return data;
};
